fragment BookingPaymentDetails on BookingNode {
  transactions {
    edges {
      node {
        id
        createdAt
        type
        providerName
        providerTransactionId
        providerFee
        value
        cardBrand
        last4
      }
    }
  }
}
